import React from "react";
import URLs from "constants/urls";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import ProductBusiness from "../Reports/productBusiness";
export default function ProductWiseBusiness() {
  return (
    <DashboardLayout>
      <ProductBusiness
        productWiseBusinesByDateRange={URLs.productWiseBusinesByDateRange}
        productWiseBusinessByProductId={URLs.productWiseBusinessByProductId}
      />
    </DashboardLayout>
  );
}
